import {AddCartTypes} from "../utils/consts";
import addCart from "./addCart/addCart";
import changeCount from "./changeCount/changeCount";
import getPrice from "./getPrice/getPrice";
import removeItem from "./removeItem/removeItem";

export const changeAmountCount = (amount, type) => {
  const countElement = document.querySelector(`.js-cart-count`);

  console.log("changeAmountCount init");

  let count = +countElement.textContent;

  switch (type) {
    case AddCartTypes.PLUS:
      count += amount;
      break;
    case AddCartTypes.MINUS:
      count -= amount;
      break;
  }

  countElement.textContent = count;
};

const cart = ({formSelector = `.js-get-price`, cartSelector = `.js-cart`}) => {
  const form = document.querySelector(formSelector);
  const cart = document.querySelector(cartSelector);

  const state = {
    current: {},
    id: ``,
  };

  const setInitialStateValues = (form) => {
    const formData = new FormData(form);
    const json = Object.fromEntries(formData.entries());

    state.id = form.dataset.id;
    state.current = Object.assign({}, json);
  };

  if (form) {
    setInitialStateValues(form);

    getPrice({state, form});
    addCart({state});
  }

  if (cart) {
    changeCount({cart});
    removeItem({cart});
  }

  // addCart({state});
};

export default cart;
